import Vue from 'vue';
import KingsLink from '~/components/shared/KingsLink.vue';

Vue.component('kings-link', KingsLink);
